var _g, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgClockForward = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  }, /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    stroke: "#449FDB",
    opacity: ""
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.088 28.5c22.084 0 40 17.912 40 40 0 22.084-17.916 40-40 40-22.092 0-40-17.916-40-40 0-22.088 17.908-40 40-40zM47.088 23.5c-24.812 0-45 20.184-45 45s20.188 45 45 45c24.812 0 45-20.184 45-45s-20.188-45-45-45v0z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.084 70.5c-1.1 0-2-0.9-2-2 0-31.984-26.020-58-58-58-1.104 0-2-0.896-2-2s0.896-2 2-2c34.184 0 62 27.812 62 62 0 1.1-0.892 2-2 2z",
    fill: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.084 71.752c-0.608 0-1.184-0.272-1.568-0.752l-12.964-16.252c-0.688-0.864-0.548-2.124 0.316-2.808 0.872-0.692 2.12-0.552 2.812 0.312l10.956 13.74 7.46-15.916c0.468-1 1.656-1.432 2.664-0.96 1 0.468 1.424 1.66 0.956 2.66l-8.832 18.832c-0.288 0.62-0.892 1.056-1.58 1.132-0.064 0.012-0.148 0.012-0.22 0.012z",
    fill: "#000000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.088 70.5c-0.512 0-1.024-0.196-1.416-0.584-0.78-0.78-0.78-2.048 0-2.828l20-20c0.78-0.78 2.048-0.78 2.828 0s0.78 2.044 0 2.828l-20 20c-0.388 0.388-0.9 0.584-1.412 0.584z",
    fill: "#000000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.088 70.5c-0.512 0-1.024-0.196-1.416-0.584l-15-15c-0.78-0.784-0.78-2.048 0-2.828s2.048-0.78 2.828 0l15 15c0.78 0.78 0.78 2.048 0 2.828-0.388 0.388-0.9 0.584-1.412 0.584z",
    fill: "#000000"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClockForward, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Clock-Forward.f95f23d9.svg";
export { ForwardRef as ReactComponent };